export default "__VITE_ASSET__DuxQK$0___"